// frontend/src/lib/entitlementOverride.js
// Local entitlement override storage helpers (ADR-COP-002B).
//
// This module stores test-only entitlement data. It does not grant authority.
// Every consumer that can affect commercial access must independently verify
// MANAGE_PLATFORM_SECURITY through the certified backend capability service.
//
// © 2026 Advanced Advisory Services, LLC. All Rights Reserved.

const LS_OVERRIDE_KEY = "aifine_entitlement_override_v1";

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function readEntitlementOverride() {
  try {
    const raw = window.localStorage.getItem(LS_OVERRIDE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return isPlainObject(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeEntitlementOverride(next) {
  try {
    if (!next) {
      window.localStorage.removeItem(LS_OVERRIDE_KEY);
      return true;
    }

    if (!isPlainObject(next)) return false;

    window.localStorage.setItem(LS_OVERRIDE_KEY, JSON.stringify(next));
    return true;
  } catch {
    return false;
  }
}

export function clearEntitlementOverride() {
  try {
    window.localStorage.removeItem(LS_OVERRIDE_KEY);
    return true;
  } catch {
    return false;
  }
}
